import React from 'react';
import './styles.css';

function DotLoader() {
    return <div className="dot-flashing"></div>;
}

export default DotLoader;
